import { render, staticRenderFns } from "./QualificationsDialog.vue?vue&type=template&id=1ff7ff65&"
import script from "./QualificationsDialog.vue?vue&type=script&lang=js&"
export * from "./QualificationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./QualificationsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports